
<!-- 官网首页 -->
<template>
  <div class="home">
    <section class="home-character">
      <h1>盘活企业现金流</h1>
      <h2>降低供应链中的成本，提升整体资金周转效率，为供应链各方创造价值。</h2>
      <div class="box-container">
        <div class="box">
          <h2>我是大型企业</h2>
          <p>我要盘活企业现金流，降低供应链中的成本</p>
          <a href="javascript:void(0);" @click="topage('core')">进一步了解</a>
          <a href="javascript:void(0);" @click="topage('core','form')">联系顾问团</a>
        </div>
        <div class="box">
          <h2>我是银行</h2>
          <p>我要为优质企业提供资金，完成支小目标</p>
          <a href="javascript:void(0);" @click="topage('institution')">进一步了解</a>
          <a href="javascript:void(0);" @click="topage('institution','form')">联系资金组</a>
        </div>
      </div>
    </section>
    <section class="home-case">
      <h1>专业团队&灵活方案</h1>
      <h2>作为专注于供应链金融长尾的互联网交易平台，群星的团队拥有业内丰富的经验，</h2>
      <h2>能够提供灵活的资金解决方案，您也将享受到其他金融公司无法支持的供应链金融服务。</h2>
    </section>
    <section class="home-digit">
      <div class="box-container">
        <div class="box">
          <span>154</span>家核心
          <p>多家核心企业在使用</p>
          <p>供应链金融平台</p>
        </div>
        <div class="box">
          <span>80</span>个省市
          <p>数万家企业和供应商</p>
          <p>享受群星平台服务</p>
        </div>
        <div class="box">
          <span>6</span>年经验
          <p>深耕多年的</p>
          <p>供应链金融业务经验</p>
        </div>
        <div class="box">
          <span>130</span>亿元
          <p>群星金融贸易流量</p>
          <p>已达到130亿元</p>
        </div>
      </div>
    </section>
    <section class="home-win">
      <h1 class="large">享受共赢</h1>
      <h2>降低供应链中的成本，提升整体资金周转效率，为供应链各方创造价值。</h2>
      <div class="box-container">
        <div class="box">
          <p class="title">我是大型企业</p>
          <p>企业等同于获得一张“信用卡”</p>
          <p>在获得经营性现金流的同时，不占用贷款和发债额度</p>
          <div class="a-container">
            <a href="javascript:void(0);" @click="topage('core','n1')">我想延长供应商账期</a>
            <a href="javascript:void(0);" @click="topage('core','1n')">我想提前收取经销商货款</a>
          </div>
          <img
            src="/imgs/portal/home/visa@2x.png"
            alt="icon"
            width="240"
          >
        </div>
        <div class="box">
          <p class="title">我是银行</p>
          <p>响应国务院政策，完成中小微企业新开户数</p>
          <p>以及给中小微企业放款金额的指标</p>
          <div class="a-container">
            <a href="javascript:void(0);" @click="topage('institution')">我想开展供应链金融业务</a>
          </div>
          <img
            src="/imgs/portal/home/bank@2x.png"
            alt="icon"
            width="280"
          >
        </div>
        <div class="box">
          <p class="title">我是供应商/经销商</p>
          <p>享受货款现结，延长账期</p>
          <p>扩大销售规模，无需再面对资金难题</p>
          <div class="a-container">
            <a href="javascript:void(0);" @click="topage('chain','n1')">我想提前收到货款</a>
            <a href="javascript:void(0);" @click="topage('chain','1n')">我想延长付款账期</a>
          </div>
          <img
            src="/imgs/portal/home/iphone@2x.png"
            alt="icon"
            width="270"
          >
        </div>
      </div>
    </section>
    <section class="home-service">
      <h1 class="large">全方位的供应链金融服务</h1>
      <a href="javascript:void(0);" @click="topage('service')">进一步了解</a>
      <div class="box-container">
        <div class="box">
          <img
            src="/imgs/portal/home/zijin_1@2x.png"
            alt="icon"
          >
          <p>资金方案</p>
        </div>
        <div class="box">
          <img
            src="/imgs/portal/home/data_1@2x.png"
            alt="icon"
          >
          <p>数据分析</p>
        </div>
        <div class="box">
          <img
            src="/imgs/portal/home/lianshu_1@2x.png"
            alt="icon"
          >
          <p>链属营销</p>
        </div>
        <div class="box">
          <img
            src="/imgs/portal/home/line_1@2x.png"
            alt="icon"
          >
          <p>线上平台</p>
        </div>
      </div>
    </section>
    <section class="home-map">
      <header>
        <h1>目前有80个省市的数万家中小企业使用群星平台</h1>
        <img src="/imgs/portal/home/map@2x.png" alt="icon">
        <h2>现在开始体验供应链金融服务</h2>
        <div class="download" @click="topage('download?page=download-home')">
          <span>下载方案</span>
          <img src="/imgs/portal/home/download@2x.png" alt="icon">
        </div>
      </header>
      <Footer class="home-footer" :page='"download-home"' />
    </section>
  </div>
</template>

<script>
import Footer from './HomeFooter'

export default {
  data () {
    return {
    }
  },
  components: {
    Footer
  },
  methods: {
    topage (way, type) {
      this.$router.push({
        path: way,
        query:
          {type: type}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding-top: 96px;
  color: #ffffff;
  text-align: center;
  background: #f2f2f2;
  min-width: 1300px;
  .box-container {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  h1 {
    font-size: 32px;
    letter-spacing: 2px;
    margin-bottom: 10px;
    &.large {
      color: #222222;
      font-size: 38px;
      margin-top: 60px;
    }
  }
  h2 {
    font-size: 21px;
    letter-spacing: 0.5px;
    margin: 0;
    font-weight: 500;
  }
  p {
    font-size: 16px;
    letter-spacing: 0.5px;
    margin: 10px 0 20px 0;
  }
  a {
    font-size: 14px;
    color: #0070c9;
    letter-spacing: 0.29px;
    margin: 0 25px;
    &::after {
      content: "";
      display: inline-block;
      position: relative;
      left: 5px;
    }
  }
  .home-character {
    padding-top: 15px;
    background: #000000 url("/imgs/portal/home/bg1_homepage@2x.png") center 0
      no-repeat;
    background-size: 1280px 380px;
    border-bottom: 16px solid #222328;
    .box-container {
      margin: 50px auto;
      .box {
        width: 455px;
        height: 142px;
        background: rgba($color: #222328, $alpha: 0.7);
        border-radius: 4px;
        padding: 22px 0 25px 0;
        box-sizing: border-box;
        a {
          color: #66bbff;
          margin: 0 25px;
          &::after {
            width: 6px;
            height: 12px;
            background: url("/imgs/portal/home/enter@2x.png") 0 no-repeat;
            background-size: 6px 8px;
            top: 1px;
          }
        }
      }
    }
  }
  .home-case {
    padding: 30px 0 60px 0;
    background: #000000 url("/imgs/portal/home/bg2_homepage@2x.png") center 0
      no-repeat;
    background-size: 1360px 228px;
  }
  .home-digit {
    margin-top: 16px;
    background: #ffffff;
    padding: 40px 0;
    .box-container {
      color: #000000;
      .box {
        letter-spacing: 2px;
        font-size: 24px;
        font-weight: 600;
        span {
          font-size: 50px;
          color: #111111;
        }
        p {
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          font-weight: 500;
          margin: 0;
        }
      }
    }
  }
  .home-win {
    color: #333333;
    .box-container {
      width: 1232px;
      margin-top: 30px;
      .box {
        background: #ffffff;
        width: 400px;
        height: 340px;
        padding-top: 40px;
        position: relative;
        box-sizing: border-box;
        p {
          margin: 5px;
          font-size: 14px;
        }
        .title {
          font-size: 28px;
          letter-spacing: 1px;
          font-weight: 600;
        }
        .a-container {
          margin: 15px 0;
          a {
            margin: 0 12px;
            &::after {
              background: url("/imgs/portal/home/enter2@2x.png") 0 no-repeat;
              background-size: 100%;
              width: 6px;
              height: 8px;
              top: -1px;
            }
          }
        }
        img {
          position: absolute;
          bottom: 0;
          left: 19%;
        }
        &:nth-child(2) {
          img {
            left: 16%;
          }
        }
        &:nth-child(3) {
          img {
            left: 10%;
          }
        }
      }
    }
  }
  .home-service {
    padding-bottom: 50px;
    color: #333333;
    a {
      font-size: 24px;
      letter-spacing: 0.5px;
      margin: 0 12px;
      &::after {
        background: url("/imgs/portal/home/enter3@2x.png") 0 no-repeat;
        background-size: 100%;
        width: 8px;
        height: 16px;
      }
    }
    .box-container {
      margin-top: 50px;
      p {
        font-size: 21px;
        font-weight: 600;
      }
      img {
        height: 90px;
      }
    }
  }
  .home-map {
    background: #222328;
    header{
      width: 1000px;
      display: block;
      margin: 0 auto;
      padding: 70px 0 0;
      overflow: hidden;
      h1{
        padding-bottom: 36px;
        margin: 0;
      }
      img{
        width: 641px;
        display: block;
        float: left;
      }
      h2{
        margin-top: 150px;
        font-family: PingFangSC-Medium;
        font-size: 21px;
        color: #FFFFFF;
        letter-spacing: 0.75px;
        text-align: center;
        line-height: 32px;
      }
      .download{
        background: #1F5DEA;
        border-radius: 4px;
        width: 215px;
        display: inline-block;
        padding: 18px;
        box-sizing: border-box;
        margin-top: 20px;
        cursor: pointer;
        span{
          display: inline-block;
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          line-height: 22px;
          margin-left: 6px;
          padding-right: 31px;
          border-right: 1px solid rgba(255, 255, 255, 0.2);
        }
        img{
          display: inline-block;
          vertical-align: baseline;
          width: 15px;
          float: none;
          margin-left: 18px;
        }
      }
    }
    .home-footer{
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?ade9ff82